import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/a11y';
import {
    A11y,
    Autoplay,
    Navigation,
} from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="lista_artigos_section"]');

class ListaArtigosSection {
    constructor() {
        MODULE.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const swiperEl = component.querySelector('[data-articles-swiper]');

        if (!swiperEl || component.dataset.articlesInitialized) {
            return;
        }

        component.dataset.articlesInitialized = 'true';

        const desktop = window.matchMedia('(min-width: 1024px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const navigation = component.querySelector('[data-articles-navigation]');
        let swiper = null;

        const syncState = (instance) => {
            const visibleSlides = instance.visibleSlides || [];
            const activeElement = document.activeElement;
            let restoreFocus = false;

            instance.slides.forEach((slide) => {
                const visible = visibleSlides.includes(slide);

                if (!visible && slide.contains(activeElement)) {
                    restoreFocus = true;
                }

                slide.inert = !visible;
            });

            if (navigation) {
                navigation.hidden = instance.isLocked;

                if (navigation.hidden && navigation.contains(activeElement)) {
                    restoreFocus = true;
                }
            }

            if (restoreFocus) {
                visibleSlides[0]?.querySelector('[data-article-link]')?.focus({
                    preventScroll: true,
                });
            }
        };

        const syncLayout = () => {
            if (desktop.matches) {
                if (swiper) {
                    swiper.destroy(true, true);
                    swiper = null;
                }

                swiperEl.querySelectorAll('[data-article-slide]').forEach((slide) => {
                    slide.inert = false;
                });

                if (navigation) {
                    if (navigation.contains(document.activeElement)) {
                        swiperEl.querySelector('[data-article-link]')?.focus({
                            preventScroll: true,
                        });
                    }

                    navigation.hidden = true;
                }

                return;
            }

            if (swiper) {
                return;
            }

            swiper = new Swiper(swiperEl, {
                modules: [
                    A11y,
                    Autoplay,
                    Navigation,
                ],
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 22,
                watchOverflow: true,
                watchSlidesProgress: true,
                speed: reducedMotion.matches
                    ? 0
                    : 300,
                autoplay: reducedMotion.matches
                    ? false
                    : {
                        delay: 5000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true,
                    },
                navigation: {
                    nextEl: component.querySelector('[data-articles-next] button'),
                    prevEl: component.querySelector('[data-articles-prev] button'),
                },
                a11y: {
                    prevSlideMessage: 'Conteúdo anterior',
                    nextSlideMessage: 'Próximo conteúdo',
                },
                on: {
                    init: syncState,
                    update: syncState,
                    setTranslate: syncState,
                    slideChange: syncState,
                    lock: syncState,
                    unlock: syncState,
                },
            });
        };

        const update = () => {
            if (swiper && !swiper.destroyed) {
                swiper.update();
            }
        };

        desktop.addEventListener('change', syncLayout);
        component.addEventListener('focusin', () => {
            swiper?.autoplay?.pause();
        });
        component.addEventListener('focusout', (event) => {
            if (!component.contains(event.relatedTarget) && swiper?.autoplay?.running) {
                swiper.autoplay.resume();
            }
        });
        swiperEl.addEventListener('load', update, true);
        document.fonts?.ready.then(update);
        syncLayout();
    }
}

if (MODULE.length) {
    new ListaArtigosSection();
}

export default ListaArtigosSection;
